import React, { useState } from 'react';
import { cilPencil, cilReload, cilTrash } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import { CCol, CRow } from '@coreui/react';
import DAaddPartnerModal from '../Modals/DAaddPartnerModal';
import { useShowConfirmation } from 'src/hooks/useShowConfirmation';
import { useShowSnackbar } from 'src/hooks/useShowSnackbar';

const DspsAddPartnerCell = (prop) => {
  const showConfirmation = useShowConfirmation();
  const showSnackbar = useShowSnackbar();
  const { params, partner, allPartners, setRows } = prop;
  const [addPartnerModalOpen, setAddPartnerModalOpen] = useState(false);

  const toggleStatus = (status) => {
    showConfirmation({
      header: 'Confirmation!',
      body: `Are you sure you want to ${status === 1 ? 're active' : 'delete'}  ${'ad'}?`,
      isOpen: true,
      onYes: () => onYesToggle(status),
      onNo: () => onNoConfirm(),
    });
  };

  const onYesToggle = async (status) => {
    if (params.row.uid === 0) {
      setRows((prevRows) => prevRows.filter((row) => row.fullName !== params.row.fullName));
    } else {
      setRows((prevRows) =>
        prevRows.map((row, index) =>
          index + 1 === params.row.id ? { ...row, status: status } : row,
        ),
      );
    }

    showSnackbar(
      `${partner.fullName} ${status === 1 ? 're activated' : 'deleted'} successfully`,
      'success',
    );
    onNoConfirm();
  };

  const onNoConfirm = () => {
    showConfirmation({
      isOpen: false,
    });
  };

  return (
    <React.Fragment>
      {params.row.status === 6 ? (
        <CRow>
          <CCol>
            <CIcon onClick={() => toggleStatus(1)} className="stock-toggle-icon" icon={cilReload} />
          </CCol>
        </CRow>
      ) : (
        <CRow>
          <CCol>
            <CIcon
              className="stock-toggle-icon"
              onClick={() => setAddPartnerModalOpen(true)}
              icon={cilPencil}
            />
          </CCol>
          <CCol>
            <CIcon className="stock-toggle-icon" onClick={() => toggleStatus(6)} icon={cilTrash} />
          </CCol>
        </CRow>
      )}

      <DAaddPartnerModal
        isOpen={addPartnerModalOpen}
        toggle={() => setAddPartnerModalOpen(!addPartnerModalOpen)}
        partner={partner}
        rows={params.row}
        setRows={setRows}
        allPartners={allPartners}
        isAdd={false}
      />
    </React.Fragment>
  );
};
export default DspsAddPartnerCell;
